export const Results = {
  Success: 'success',
  Error: 'error',
};
